export default "https://cdn-static.gokick.com/assets/4215e61f258b66d5599ee2c3a2c4c86e46d29fa2/images/sleep-bottles.21ff427124b73aa7b2cf5884e65ef589.jpg";